import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id 1173684B-E68C-4BE5-BD9C-53C01A619896
 * name network-strength-4-alert
 * version: 2.3.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/network-strength-4-alert.svg
 * tags
 * - Cellphone / Phone 
 * - Alert / Error 
 */
export const NetworkStrength4AlertIcon = createSvgIcon(<><path d="M19 17H21V11H19M19 21H21V19H19M1 21H17V9H21V1" /></>, 'NetworkStrength4AlertIcon');
export default NetworkStrength4AlertIcon